import { streetItems } from "@/mocks/home";

export default function StreetFeed() {
  return (
    <section className="border-t border-background-200/70 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mb-8 flex scroll-mt-24 flex-col gap-3 md:mb-10 md:flex-row md:items-end md:justify-between" id="street">
          <div>
            <p className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-widest2 text-accent-700">
              <span className="font-heading text-base">03</span>
              <span className="h-px w-6 bg-accent-500" />
            </p>
            <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              街拍照片 · 持续更新
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              工作日与周末双轨采样，路人视角直出，同款穿搭记录在下文一一拆解。
            </p>
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              只看街拍 <i className="ri-filter-2-line" />
            </button>
            <a
              href="#covers"
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-secondary-100 px-4 py-2 text-sm font-medium text-secondary-900 transition-colors hover:bg-secondary-200"
            >
              <i className="ri-calendar-line" /> 更新时间线
            </a>
          </div>
        </div>

        <div className="columns-1 gap-5 sm:columns-2 lg:columns-3">
          {streetItems.map((s) => (
            <article
              key={s.id}
              className="group mb-5 cursor-pointer break-inside-avoid overflow-hidden rounded-lg bg-background-100"
            >
              <div className="relative overflow-hidden">
                <img
                  src={s.img}
                  alt={`吃瓜图集${s.kind}：${s.title}`}
                  title={`吃瓜图集 · ${s.kind}`}
                  className={`w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04] ${
                    s.ratio === "tall" ? "aspect-[3/4]" : "aspect-[4/3]"
                  }`}
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-[11px] text-primary-700">
                  {s.kind}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-[15px] font-bold leading-snug text-foreground-950">
                  {s.title}
                </h3>
                <p className="mt-2 text-xs leading-relaxed text-foreground-500">{s.note}</p>
                <div className="mt-3 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-400">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-map-pin-line" /> {s.place}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-time-line" /> {s.date}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href="#street"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            加载更多街拍照片 <i className="ri-add-line" />
          </a>
        </div>
      </div>
    </section>
  );
}